import {Box, memoWithType, SelectDateRangePicker} from "@hosttools/frontend";
import type {Column, Table} from "@tanstack/react-table";
import {useCallback, useState} from "react";

interface Props<T> {
    table: Table<T>;
    column: Column<T, unknown>;
    className?: string;
    defaultStartDate?: Date;
    defaultEndDate?: Date;
}

const FilterDateRange = <T,>({
    table,
    column,
    className,
    defaultStartDate,
    defaultEndDate
}: Props<T>) => {
    if (column.columnDef.filter?.type !== "dateRange") {
        throw new Error("Wrong type set!");
    }

    const [startDate, setStartDate] = useState<Date | undefined>(defaultStartDate);
    const [endDate, setEndDate] = useState<Date | undefined>(defaultEndDate);

    const handleDatePickerChange = useCallback(
        (startDate?: Date, endDate?: Date) => {
            setStartDate(startDate);
            setEndDate(endDate);
            if (startDate && endDate) {
                table.setPageIndex(0);
                column.setFilterValue({startDate, endDate});
            }
        },
        [column, table]
    );

    return (
        <Box className={className}>
            <SelectDateRangePicker
                allowQuickSelectDate
                endDate={endDate}
                startDate={startDate}
                onSelectedDates={handleDatePickerChange}
            />
        </Box>
    );
};

export default memoWithType(FilterDateRange);
